import Dropdown from 'react-bootstrap/Dropdown';

import { useCompiledContractStore } from '../../zustand/compiledContractStore';
import { useCurrentFileStore } from '../../zustand/currentFileStore';

const CompiledContractsDropdown = () => {
    const { fileName, filePath } = useCurrentFileStore()
    const { compiledContracts, currentCompiledContractName, updateCurrentCompiledContract } = useCompiledContractStore()

    return (
        <Dropdown className='compiled-contracts-dropdown'>
            <Dropdown.Toggle variant="secondary" size='sm' disabled={currentCompiledContractName === ''}>{currentCompiledContractName !== '' ? `${currentCompiledContractName} - ${filePath}${fileName}` : 'No compiled contracts'}</Dropdown.Toggle>
                <Dropdown.Menu>
                    {compiledContracts.map((contract, index) => {
                        return <Dropdown.Item as="button" key={index} onClick={() => updateCurrentCompiledContract(contract)}>{contract.name} - {contract.filePath}</Dropdown.Item>
                    })}
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default CompiledContractsDropdown